<div class="modal-content">
    <h1 mat-dialog-title>Unsaved Changes </h1>
    <div mat-dialog-content class="dialog-content">
        <b class="dialog-content-error">
            An error in saving the form has ocurred.
        </b>
        <p>
            Please contact <b>{{PhoneNumber}}</b> for assistance with filling out the form.
        </p>
    </div>
    <div mat-dialog-actions align="end">
        <button id="failed-request-ok" mat-flat-button class="btn-sm" (click)="OnClickRedirectToLogin()">Okay</button>
    </div>
</div>